import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  ids = new Set();

  constructor() {}

  isLoading = new BehaviorSubject<boolean>(false);
  isLoading$ = this.isLoading.asObservable();

  generateId() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  show() {
    const id = this.generateId();
    this.ids.add(id);

    // Isso contorna um bug bizonho do ExpressionChangedAfterItrHasBeenCheckedError.
    // Sem o "ids.has(id)" aqui, um request que termina (hide) em menos de
    // 100ms ainda liga o loader quando o timeout dispara depois - e como
    // ninguem mais chama hide() pra esse id ja removido, ele trava ligado.
    setTimeout(() => {
      if (this.ids.has(id)) {
        this.isLoading.next(true);
      }
    }, 100);
    return id;
  }

  hide(id: string) {
    if (this.ids.has(id)) {
      this.ids.delete(id);
      if (this.ids.size === 0) {
        this.isLoading.next(false);
      }
    }
  }
}
